/* tslint:disable:member-ordering */
import { Inject, Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpContext } from '@angular/common/http';
import { Observable } from 'rxjs';
import { CheckPaymentStatusResponseV1Dto } from '../model/checkPaymentStatusResponseV1Dto';
import { InitializePaymentV1Dto } from '../model/initializePaymentV1Dto';
import { PaymentInitializeResponseV1Dto } from '../model/paymentInitializeResponseV1Dto';
import { PaymentMethodResponseV1Dto } from '../model/paymentMethodResponseV1Dto';
import { BASE_PATH } from '../variables';
import { Configuration }  from '../configuration';



@Injectable({
  providedIn: 'root'
})
export class PaymentService {
    protected basePath;
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Inject(BASE_PATH) basePath: string|string[]) {
        this.basePath = basePath;
    }

    private addToHttpParams(httpParams: HttpParams, value: any, key?: string): HttpParams {
        if (typeof value === "object" && value instanceof Date === false) {
            httpParams = this.addToHttpParamsRecursive(httpParams, value);
        } else {
            httpParams = this.addToHttpParamsRecursive(httpParams, value, key);
        }
        return httpParams;
    }

    private addToHttpParamsRecursive(httpParams: HttpParams, value?: any, key?: string): HttpParams {
        if (value == null) {
            return httpParams;
        }

        if (typeof value === "object") {
            if (Array.isArray(value)) {
                (value as any[]).forEach( elem => httpParams = this.addToHttpParamsRecursive(httpParams, elem, key));
            } else if (value instanceof Date) {
                if (key != null) {
                    httpParams = httpParams.append(key, (value as Date).toISOString().substring(0, 10));
                } else {
                   throw Error("key may not be null if value is Date");
                }
            } else {
                Object.keys(value).forEach( k => httpParams = this.addToHttpParamsRecursive(
                    httpParams, value[k], key != null ? `${key}.${k}` : k));
            }
        } else if (key != null) {
            httpParams = httpParams.append(key, value);
        } else {
            throw Error("key may not be null if value is not object or array");
        }
        return httpParams;
    }

    public apiPaymentAppModulesPaymentmodulePaymentCheckpaymentstatusv1actionInvokeV1(paymentId: string, observe?: 'body', reportProgress?: boolean, options?: {responseType: 'text' | 'json' | 'blob', headers?: HttpHeaders,httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<CheckPaymentStatusResponseV1Dto> {

        let localVarPath = `/api/v1/payment/check-status/${this.configuration.encodeParam({name: "paymentId", value: paymentId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}`;
        return this.httpClient.request<CheckPaymentStatusResponseV1Dto>('get', `${this.basePath}${localVarPath}`,
            {
                responseType: options?.responseType || 'json' as any,
                observe,
                transferCache: options?.transferCache ?? true,
                reportProgress,
                headers: options?.headers
            }
        );
    }

    public apiPaymentAppModulesPaymentmodulePaymentGetpaymentmethodslistv1actionInvokeV1(platform: string, country: string, currency: string, observe?: 'body', reportProgress?: boolean, options?: {responseType: 'text' | 'json' | 'blob', headers?: HttpHeaders,httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<Array<PaymentMethodResponseV1Dto>> {

        let localVarPath = `/api/v1/payment/methods/${this.configuration.encodeParam({name: "platform", value: platform, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/${this.configuration.encodeParam({name: "country", value: country, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/${this.configuration.encodeParam({name: "currency", value: currency, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}`;
        return this.httpClient.request<Array<PaymentMethodResponseV1Dto>>('get', `${this.basePath}${localVarPath}`,
            {
                responseType: options?.responseType || 'json' as any,
                observe,
                transferCache: options?.transferCache ?? true,
                reportProgress,
                headers: options?.headers
            }
        );
    }

    public apiPaymentAppModulesPaymentmodulePaymentInitializepaymentv1actionInvokeV1(initializePaymentV1Dto: InitializePaymentV1Dto, observe?: 'body', reportProgress?: boolean, options?: {responseType: 'text' | 'json' | 'blob', headers?: HttpHeaders,httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<PaymentInitializeResponseV1Dto> {

        let localVarPath = `/api/v1/payment/initialize`;
        return this.httpClient.request<PaymentInitializeResponseV1Dto>('post', `${this.basePath}${localVarPath}`,
            {
                body: initializePaymentV1Dto,
                responseType: options?.responseType || 'json' as any,
                observe,
                transferCache: options?.transferCache ?? true,
                reportProgress,
                headers: options?.headers
            }
        );
    }

}
